import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      stroke: "#1e3f5f",
      "stroke-width": "5",
      opacity: ".2"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      stroke: "#5cccff",
      "stroke-dasharray": "45",
      "stroke-dashoffset": "-45",
      "stroke-linecap": "round",
      "stroke-width": "5"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        from: "0 25 25",
        repeatCount: "indefinite",
        to: "360 25 25",
        type: "rotate"
      })
    ], -1)
  ])))
}
export default { render: render }